export default __webpack_public_path__ + "static/media/2_notification_bell_zero.08af051b.svg";